module.exports = __webpack_public_path__ + "mo/img/piece-12.712a2354.svg";